import { PaymentElement } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';

import Button from 'honeydew/Button';
import useStripePaymentForm from 'hooks/useStripePaymentForm';
import { getStripeConfiguration } from 'utils/stripeUtils';

function PaymentOptionsForm({
    clientSecret,
    email,
    paymentSetupSuccess,
    phone,
    setPaymentSetupSuccess,
    setPaymentTypeSelected,
    setSetupIntentID,
}) {
    const { block, buttonDisabled, errorMessage, handleSubmit, showButton, stripe } = useStripePaymentForm({
        clientSecret,
        email,
        setPaymentSetupSuccess,
        setPaymentTypeSelected,
        setSetupIntentID,
    });

    return (
        <form onSubmit={handleSubmit}>
            {!paymentSetupSuccess && !block ? (
                <PaymentElement options={getStripeConfiguration({ email, phone }, null)} />
            ) : null}

            <div className="mt-25">
                {showButton && !paymentSetupSuccess && (
                    <Button type="submit" disabled={!stripe || buttonDisabled || block}>
                        Save
                    </Button>
                )}

                {errorMessage && <p className="mt-15 text-error">{errorMessage}</p>}

                {block && (
                    <p className="mt-15 text-error">
                        Temporarily blocked due to multiple attempted failures. Please try again after 24 hours.
                    </p>
                )}
            </div>
        </form>
    );
}

PaymentOptionsForm.propTypes = {
    clientSecret: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    paymentSetupSuccess: PropTypes.bool.isRequired,
    phone: PropTypes.string.isRequired,
    setPaymentSetupSuccess: PropTypes.func.isRequired,
    setPaymentTypeSelected: PropTypes.func.isRequired,
    setSetupIntentID: PropTypes.func.isRequired,
};

export default PaymentOptionsForm;
